"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDirectionForLocale = exports.getCountryFromLocale = void 0;
const constants_1 = require("./constants");
const language_direction_1 = require("./language-direction");
// todo: to be deprecated, locale is not a reliable way to get a user's country.
// https://jira.sc-corp.net/browse/WEB-2381
const getCountryFromLocale = (locale) => {
    if (locale === constants_1.Locale.enPLOC) {
        return "US";
    }
    if (locale === constants_1.Locale.pa) {
        return "IN";
    }
    if (locale.length === 2) {
        // es, ar
        return locale.toUpperCase();
    }
    if (locale === constants_1.Locale.zhHans || locale === constants_1.Locale.zhHant) {
        return "CN";
    }
    return locale.split(/[-_]/)[1];
};
exports.getCountryFromLocale = getCountryFromLocale;
const getDirectionForLocale = (locale) => constants_1.RTL_LOCALES.includes(locale) ? language_direction_1.LanguageDirection.RTL : language_direction_1.LanguageDirection.LTR;
exports.getDirectionForLocale = getDirectionForLocale;
//# sourceMappingURL=localeUtils.js.map